import { render, staticRenderFns } from "./point-form.vue?vue&type=template&id=762632ea"
import script from "./point-form.vue?vue&type=script&lang=js"
export * from "./point-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports